const canWriteItems = () =>
	typeof ClipboardItem !== "undefined" &&
	typeof navigator.clipboard?.write === "function"

/** Safari drops the click's permission across an await, so text that is still loading goes in as a pending ClipboardItem. */
export async function copyTextWhenReady(text: Promise<string>): Promise<void> {
	if (!canWriteItems()) {
		await navigator.clipboard.writeText(await text)
		return
	}
	await navigator.clipboard.write([
		new ClipboardItem({
			"text/plain": text.then((t) => new Blob([t], { type: "text/plain" })),
		}),
	])
}

/** Rich editors (Slack, Linear, Notion) paste the HTML link; plain fields get the text. */
export async function copyRichText({
	text,
	html,
}: {
	text: string
	html: string
}): Promise<void> {
	if (!canWriteItems()) {
		await navigator.clipboard.writeText(text)
		return
	}
	await navigator.clipboard.write([
		new ClipboardItem({
			"text/plain": new Blob([text], { type: "text/plain" }),
			"text/html": new Blob([html], { type: "text/html" }),
		}),
	])
}
